import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Save, X, Star } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const COUNTRIES = ["MX", "US", "ES", "AR", "CO", "CL", "PE", "VE", "EC", "BO", "PY", "UY", "GT", "HN", "SV", "NI", "CR", "PA", "DO", "CU", "PR", "BR", "CA", "OT"];

/* Inline editor: admin can change name, country, rating, text of any testimonial. */
export const AdminCommentEditor = ({ comment, authHeader, onSaved, onCancel }) => {
  const [form, setForm] = useState({
    name: comment.name || "", country: (comment.country || "MX").toUpperCase(),
    rating: comment.rating || 5, text: comment.text || "", service: comment.service || "",
  });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (form.text.trim().length < 10) return toast.error("El comentario debe tener al menos 10 caracteres");
    if (form.name.trim().length < 2) return toast.error("Nombre demasiado corto");
    setSaving(true);
    try {
      await axios.patch(`${API}/admin/user-comments/${comment.id}`, {
        name: form.name.trim(), country: form.country, rating: Number(form.rating), text: form.text.trim(),
        service: form.service || undefined,
      }, { headers: authHeader?.() || {} });
      toast.success("Testimonio actualizado");
      onSaved?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "No se pudo guardar");
    } finally { setSaving(false); }
  };

  return (
    <div className="mt-3 rounded-xl border border-[#d4af37]/30 bg-black/40 p-3 space-y-2" data-testid={`user-comment-editor-${comment.id}`}>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        <input data-testid="comment-edit-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nombre" className="bg-black/50 border border-white/10 rounded px-2 py-1.5 text-sm text-white" />
        <select data-testid="comment-edit-country" value={form.country} onChange={(e) => setForm({ ...form, country: e.target.value })} className="bg-black/50 border border-white/10 rounded px-2 py-1.5 text-sm text-white">
          {!COUNTRIES.includes(form.country) && <option value={form.country}>{form.country}</option>}
          {COUNTRIES.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <div className="flex items-center gap-1 px-1" data-testid="comment-edit-rating">
          {[1, 2, 3, 4, 5].map((s) => (
            <button key={s} type="button" data-testid={`comment-edit-star-${s}`} onClick={() => setForm({ ...form, rating: s })}>
              <Star className={`w-4 h-4 ${s <= form.rating ? "text-[#d4af37] fill-[#d4af37]" : "text-neutral-600"}`} />
            </button>
          ))}
        </div>
      </div>
      <textarea data-testid="comment-edit-text" rows={4} value={form.text} onChange={(e) => setForm({ ...form, text: e.target.value })} className="w-full bg-black/50 border border-white/10 rounded px-2 py-1.5 text-sm text-white" />
      <div className="flex justify-end gap-2">
        <button data-testid="comment-edit-cancel" onClick={onCancel} className="text-[10px] uppercase tracking-widest px-3 py-1.5 rounded border border-white/15 text-neutral-300 hover:bg-white/5 flex items-center gap-1"><X className="w-3 h-3" /> Cancelar</button>
        <button data-testid="comment-edit-save" onClick={save} disabled={saving} className="text-[10px] uppercase tracking-widest px-3 py-1.5 rounded bg-[#d4af37] text-black font-bold hover:bg-[#e6c35a] flex items-center gap-1 disabled:opacity-50">
          {saving ? <Loader2 className="w-3 h-3 animate-spin" /> : <Save className="w-3 h-3" />} Guardar
        </button>
      </div>
    </div>
  );
};

export default AdminCommentEditor;
